/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToEmWithBaseline, themeV2 } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : RATING CODE : STYLES --------------- ++++++++++ */
export default theme => ({
  commentingadvancedsection: {
    '& .collapsable': {
      '& .innerWrap': {
        padding: 0
      },
      '&.opened': {
        overflow: 'visible',
        '& .innerWrap': {
          padding: pxToEm(16)
        }
      }
    },
    '& .loadingsection': { minHeight: pxToEm(300) }, 
    '& .advanced': {
      display: 'flex',
      flexDirection: 'column',
      '& > *': {
        marginTop: '16px'
      },
      '& .migration': {
        fontSize: pxToEm(16),
        lineHeight: pxToEmWithBaseline({ value: 20, fontSizeBaseline: 16 }),
        display: 'flex',
        flexDirection: 'column'
      },
      '& .code': {
        '& .copysnippetfield': {
          margin: `${pxToEm(32)} 0`,
          '& .copyfield': {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            margin: `${pxToEm(8)} 0`,
            '& .field': {
              margin: 0,
              marginRight: pxToEm(8)
            }
          }
        }
      }
    },
    '& .directions': {
      '& h4': { color: themeV2.color.primary.main, marginBottom: pxToEm(16) },
      '& ol': {
        fontSize: pxToEm(14),
        fontWeight: 400,
        marginLeft: pxToEm(30),
        marginTop: pxToEm(12),
        marginBottom: pxToEm(16),
        '& li': { marginBottom: pxToEm(8) }
      }
    },
    '& .migration': {
      '& .inlinemessage': { margin: `${pxToEm(20)} 0 ${pxToEm(30)}` },
      '& .name-notrequiredmsg': { marginTop: pxToEm(30) },
      '& .status': { margin: `${12}px 0`},
      '& .notrequired-true': { marginTop: `${pxToEm(18)}` }
    }
  }
});
